import {
  OPERATOR_TYPES_1,
  OPERATOR_TYPES_2,
  OPERATOR_TYPES_3,
  OPERATOR_TYPES_6,
  OPERATOR_TYPES_BOOLEAN,
} from './operators';

export const AUTOMATIONS = {
  message_created: {
    conditions: [
      {
        key: 'message_type',
        name: 'MESSAGE_TYPE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'content',
        name: 'MESSAGE_CONTAINS',
        inputType: 'comma_separated_plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'add_label',
        name: 'ADD_LABEL',
      },
      {
        key: 'remove_label',
        name: 'REMOVE_LABEL',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
    ],
  },
  conversation_created: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'create_ticket',
        name: 'CREATE_TICKET',
      },
      {
        key: 'link_to_ticket',
        name: 'LINK_TO_TICKET',
      },
    ],
  },
  conversation_updated: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
    ],
  },
  conversation_opened: {
    conditions: [
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
    ],
  },
  conversation_resolved: {
    conditions: [
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
    ],
  },
  // Ticket Events
  ticket_created: {
    conditions: [
      {
        key: 'ticket_status',
        name: 'TICKET_STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_priority',
        name: 'TICKET_PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_category_id',
        name: 'TICKET_CATEGORY',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_subcategory_id',
        name: 'TICKET_SUBCATEGORY',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_channel',
        name: 'TICKET_CHANNEL',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_assignee_id',
        name: 'TICKET_ASSIGNEE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'client_name',
        name: 'CLIENT_NAME',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'contract_number',
        name: 'CONTRACT_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'explotacion',
        name: 'EXPLOTACION',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'update_ticket_status',
        name: 'UPDATE_TICKET_STATUS',
      },
      {
        key: 'update_ticket_priority',
        name: 'UPDATE_TICKET_PRIORITY',
      },
      {
        key: 'assign_ticket',
        name: 'ASSIGN_TICKET',
      },
      {
        key: 'assign_ticket_to_team',
        name: 'ASSIGN_TICKET_TO_TEAM',
        inputType: 'search_select',
      },
      {
        key: 'escalate_ticket',
        name: 'ESCALATE_TICKET',
      },
      {
        key: 'add_ticket_note',
        name: 'ADD_TICKET_NOTE',
      },
      {
        key: 'create_service_order',
        name: 'CREATE_SERVICE_ORDER',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
    ],
  },
  ticket_updated: {
    conditions: [
      {
        key: 'ticket_status',
        name: 'TICKET_STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_priority',
        name: 'TICKET_PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_category_id',
        name: 'TICKET_CATEGORY',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_subcategory_id',
        name: 'TICKET_SUBCATEGORY',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_channel',
        name: 'TICKET_CHANNEL',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_assignee_id',
        name: 'TICKET_ASSIGNEE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'sla_breached',
        name: 'SLA_BREACHED',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_BOOLEAN,
      },
      {
        key: 'client_name',
        name: 'CLIENT_NAME',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'contract_number',
        name: 'CONTRACT_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'explotacion',
        name: 'EXPLOTACION',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'update_ticket_status',
        name: 'UPDATE_TICKET_STATUS',
      },
      {
        key: 'update_ticket_priority',
        name: 'UPDATE_TICKET_PRIORITY',
      },
      {
        key: 'assign_ticket',
        name: 'ASSIGN_TICKET',
      },
      {
        key: 'escalate_ticket',
        name: 'ESCALATE_TICKET',
      },
      {
        key: 'resolve_ticket',
        name: 'RESOLVE_TICKET',
      },
      {
        key: 'close_ticket',
        name: 'CLOSE_TICKET',
      },
      {
        key: 'add_ticket_note',
        name: 'ADD_TICKET_NOTE',
      },
      {
        key: 'create_service_order',
        name: 'CREATE_SERVICE_ORDER',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'notify_linked_conversation',
        name: 'NOTIFY_LINKED_CONVERSATION',
      },
      {
        key: 'sync_conversation_status',
        name: 'SYNC_CONVERSATION_STATUS',
      },
      {
        key: 'sync_conversation_assignee',
        name: 'SYNC_CONVERSATION_ASSIGNEE',
      },
      {
        key: 'add_conversation_note',
        name: 'ADD_CONVERSATION_NOTE',
      },
    ],
  },
  ticket_status_changed: {
    conditions: [
      {
        key: 'ticket_status',
        name: 'TICKET_STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_priority',
        name: 'TICKET_PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_assignee_id',
        name: 'TICKET_ASSIGNEE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'explotacion',
        name: 'EXPLOTACION',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'update_ticket_priority',
        name: 'UPDATE_TICKET_PRIORITY',
      },
      {
        key: 'assign_ticket',
        name: 'ASSIGN_TICKET',
      },
      {
        key: 'add_ticket_note',
        name: 'ADD_TICKET_NOTE',
      },
      {
        key: 'create_service_order',
        name: 'CREATE_SERVICE_ORDER',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
    ],
  },
  ticket_assigned: {
    conditions: [
      {
        key: 'ticket_status',
        name: 'TICKET_STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_priority',
        name: 'TICKET_PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_assignee_id',
        name: 'TICKET_ASSIGNEE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'explotacion',
        name: 'EXPLOTACION',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'update_ticket_status',
        name: 'UPDATE_TICKET_STATUS',
      },
      {
        key: 'add_ticket_note',
        name: 'ADD_TICKET_NOTE',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
    ],
  },
  ticket_escalated: {
    conditions: [
      {
        key: 'ticket_priority',
        name: 'TICKET_PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_category_id',
        name: 'TICKET_CATEGORY',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'explotacion',
        name: 'EXPLOTACION',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'update_ticket_priority',
        name: 'UPDATE_TICKET_PRIORITY',
      },
      {
        key: 'assign_ticket',
        name: 'ASSIGN_TICKET',
      },
      {
        key: 'add_ticket_note',
        name: 'ADD_TICKET_NOTE',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
    ],
  },
  ticket_resolved: {
    conditions: [
      {
        key: 'ticket_priority',
        name: 'TICKET_PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_category_id',
        name: 'TICKET_CATEGORY',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_assignee_id',
        name: 'TICKET_ASSIGNEE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'explotacion',
        name: 'EXPLOTACION',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'close_ticket',
        name: 'CLOSE_TICKET',
      },
      {
        key: 'add_ticket_note',
        name: 'ADD_TICKET_NOTE',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
    ],
  },
  ticket_sla_breached: {
    conditions: [
      {
        key: 'ticket_status',
        name: 'TICKET_STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_priority',
        name: 'TICKET_PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ticket_assignee_id',
        name: 'TICKET_ASSIGNEE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'explotacion',
        name: 'EXPLOTACION',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'update_ticket_priority',
        name: 'UPDATE_TICKET_PRIORITY',
      },
      {
        key: 'escalate_ticket',
        name: 'ESCALATE_TICKET',
      },
      {
        key: 'assign_ticket',
        name: 'ASSIGN_TICKET',
      },
      {
        key: 'add_ticket_note',
        name: 'ADD_TICKET_NOTE',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
    ],
  },
  // Service Order Events
  service_order_created: {
    conditions: [
      {
        key: 'order_type',
        name: 'ORDER_TYPE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'status',
        name: 'ORDER_STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'order_class',
        name: 'ORDER_CLASS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'update_ticket_status',
        name: 'UPDATE_TICKET_STATUS',
      },
      {
        key: 'add_ticket_note',
        name: 'ADD_TICKET_NOTE',
      },
      {
        key: 'notify_linked_conversation',
        name: 'NOTIFY_LINKED_CONVERSATION',
      },
      {
        key: 'close_ticket',
        name: 'CLOSE_TICKET',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
    ],
  },
  service_order_completed: {
    conditions: [
      {
        key: 'order_type',
        name: 'ORDER_TYPE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'order_class',
        name: 'ORDER_CLASS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'update_ticket_status',
        name: 'UPDATE_TICKET_STATUS',
      },
      {
        key: 'resolve_ticket',
        name: 'RESOLVE_TICKET',
      },
      {
        key: 'add_ticket_note',
        name: 'ADD_TICKET_NOTE',
      },
      {
        key: 'notify_linked_conversation',
        name: 'NOTIFY_LINKED_CONVERSATION',
      },
      {
        key: 'close_ticket',
        name: 'CLOSE_TICKET',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
    ],
  },
  service_order_status_changed: {
    conditions: [
      {
        key: 'order_type',
        name: 'ORDER_TYPE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'status',
        name: 'ORDER_STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'order_class',
        name: 'ORDER_CLASS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'update_ticket_status',
        name: 'UPDATE_TICKET_STATUS',
      },
      {
        key: 'resolve_ticket',
        name: 'RESOLVE_TICKET',
      },
      {
        key: 'close_ticket',
        name: 'CLOSE_TICKET',
      },
      {
        key: 'add_ticket_note',
        name: 'ADD_TICKET_NOTE',
      },
      {
        key: 'notify_linked_conversation',
        name: 'NOTIFY_LINKED_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
    ],
  },
};

export const AUTOMATION_RULE_EVENTS = [
  // Conversation Events
  {
    key: 'conversation_created',
    value: 'CONVERSATION_CREATED',
  },
  {
    key: 'conversation_updated',
    value: 'CONVERSATION_UPDATED',
  },
  {
    key: 'conversation_resolved',
    value: 'CONVERSATION_RESOLVED',
  },
  {
    key: 'message_created',
    value: 'MESSAGE_CREATED',
  },
  {
    key: 'conversation_opened',
    value: 'CONVERSATION_OPENED',
  },
  // Ticket Events
  {
    key: 'ticket_created',
    value: 'TICKET_CREATED',
  },
  {
    key: 'ticket_updated',
    value: 'TICKET_UPDATED',
  },
  {
    key: 'ticket_status_changed',
    value: 'TICKET_STATUS_CHANGED',
  },
  {
    key: 'ticket_assigned',
    value: 'TICKET_ASSIGNED',
  },
  {
    key: 'ticket_escalated',
    value: 'TICKET_ESCALATED',
  },
  {
    key: 'ticket_resolved',
    value: 'TICKET_RESOLVED',
  },
  {
    key: 'ticket_sla_breached',
    value: 'TICKET_SLA_BREACHED',
  },
  // Service Order Events
  {
    key: 'service_order_created',
    value: 'SERVICE_ORDER_CREATED',
  },
  {
    key: 'service_order_completed',
    value: 'SERVICE_ORDER_COMPLETED',
  },
  {
    key: 'service_order_status_changed',
    value: 'SERVICE_ORDER_STATUS_CHANGED',
  },
];

export const AUTOMATION_ACTION_TYPES = [
  {
    key: 'assign_agent',
    label: 'ASSIGN_AGENT',
    inputType: 'search_select',
  },
  {
    key: 'assign_team',
    label: 'ASSIGN_TEAM',
    inputType: 'search_select',
  },
  {
    key: 'add_label',
    label: 'ADD_LABEL',
    inputType: 'multi_select',
  },
  {
    key: 'remove_label',
    label: 'REMOVE_LABEL',
    inputType: 'multi_select',
  },
  {
    key: 'send_email_to_team',
    label: 'SEND_EMAIL_TO_TEAM',
    inputType: 'team_message',
  },
  {
    key: 'send_email_transcript',
    label: 'SEND_EMAIL_TRANSCRIPT',
    inputType: 'email',
  },
  {
    key: 'mute_conversation',
    label: 'MUTE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'snooze_conversation',
    label: 'SNOOZE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'resolve_conversation',
    label: 'RESOLVE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'open_conversation',
    label: 'OPEN_CONVERSATION',
    inputType: null,
  },
  {
    key: 'send_webhook_event',
    label: 'SEND_WEBHOOK_EVENT',
    inputType: 'url',
  },
  {
    key: 'send_attachment',
    label: 'SEND_ATTACHMENT',
    inputType: 'attachment',
  },
  {
    key: 'send_message',
    label: 'SEND_MESSAGE',
    inputType: 'textarea',
  },
  {
    key: 'add_private_note',
    label: 'ADD_PRIVATE_NOTE',
    inputType: 'textarea',
  },
  {
    key: 'change_priority',
    label: 'CHANGE_PRIORITY',
    inputType: 'search_select',
  },
  {
    key: 'add_sla',
    label: 'ADD_SLA',
    inputType: 'search_select',
  },
  // Ticket Actions
  {
    key: 'update_ticket_status',
    label: 'UPDATE_TICKET_STATUS',
    inputType: 'search_select',
  },
  {
    key: 'update_ticket_priority',
    label: 'UPDATE_TICKET_PRIORITY',
    inputType: 'search_select',
  },
  {
    key: 'assign_ticket',
    label: 'ASSIGN_TICKET',
    inputType: 'search_select',
  },
  {
    key: 'assign_ticket_to_team',
    label: 'ASSIGN_TICKET_TO_TEAM',
    inputType: 'search_select',
  },
  {
    key: 'escalate_ticket',
    label: 'ESCALATE_TICKET',
    inputType: 'search_select',
  },
  {
    key: 'resolve_ticket',
    label: 'RESOLVE_TICKET',
    inputType: 'textarea',
  },
  {
    key: 'close_ticket',
    label: 'CLOSE_TICKET',
    inputType: null,
  },
  {
    key: 'add_ticket_note',
    label: 'ADD_TICKET_NOTE',
    inputType: 'textarea',
  },
  {
    key: 'create_service_order',
    label: 'CREATE_SERVICE_ORDER',
    inputType: null,
  },
  // Cross-entity actions: Conversation → Ticket
  {
    key: 'create_ticket',
    label: 'CREATE_TICKET',
    inputType: 'search_select',
  },
  {
    key: 'link_to_ticket',
    label: 'LINK_TO_TICKET',
    inputType: 'plain_text',
  },
  // Cross-entity actions: Ticket → Conversation
  {
    key: 'notify_linked_conversation',
    label: 'NOTIFY_LINKED_CONVERSATION',
    inputType: 'textarea',
  },
  {
    key: 'sync_conversation_status',
    label: 'SYNC_CONVERSATION_STATUS',
    inputType: null,
  },
  {
    key: 'sync_conversation_assignee',
    label: 'SYNC_CONVERSATION_ASSIGNEE',
    inputType: null,
  },
  {
    key: 'add_conversation_note',
    label: 'ADD_CONVERSATION_NOTE',
    inputType: 'textarea',
  },
];
